import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';

export interface RelatorioOpcao {
  rota: string;
  titulo: string;
  curto: string;
  descricao: string;
  icone: 'agenda' | 'termo' | 'grafico';
  lideranca: boolean;
}

export const RELATORIOS: RelatorioOpcao[] = [
  { rota: '/relatorios/agenda', titulo: 'Relatórios da Agenda', curto: 'Agenda', descricao: 'Relatórios gerenciais e operacionais da Agenda', icone: 'agenda', lideranca: false },
  { rota: '/relatorios/termos', titulo: 'Termos de adesão', curto: 'Termos de adesão', descricao: 'Termos enviados e assinados, por CPF do paciente', icone: 'termo', lideranca: false },
  { rota: '/relatorios/ofertas', titulo: 'Ofertas e conversões', curto: 'Ofertas e conversões', descricao: 'Venda de planos, upsell, cobranças e particulares por médico', icone: 'grafico', lideranca: true },
];

@Component({
  selector: 'app-relatorios-abas',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    <header class="mb-5">
      <h1 class="titulo-pagina">Relatórios</h1>
      <p class="subtitulo">Escolha o relatório que quer consultar.</p>
    </header>
    <nav class="opcoes mb-5" aria-label="Relatórios">
      <a *ngFor="let r of opcoes" [routerLink]="r.rota" routerLinkActive="ativa" #ativo="routerLinkActive"
         class="opcao" [attr.aria-current]="ativo.isActive ? 'page' : null">
        <span class="icone" aria-hidden="true">
          <svg *ngIf="r.icone === 'agenda'" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18M8 14h3M8 17h6"/>
          </svg>
          <svg *ngIf="r.icone === 'termo'" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/>
          </svg>
          <svg *ngIf="r.icone === 'grafico'" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/>
          </svg>
        </span>
        <span class="texto">
          <span class="nome">{{ r.titulo }}</span>
          <span class="descricao">{{ r.descricao }}</span>
        </span>
      </a>
    </nav>`,
  styles: [`
    .titulo-pagina { font-size: 22px; font-weight: 800; color: var(--tx); margin: 0; letter-spacing: -.01em; }
    .subtitulo { font-size: 13px; color: var(--tx-3); margin: 2px 0 0; }
    .opcoes { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 10px; }
    .opcao { display: flex; align-items: flex-start; gap: 12px; padding: 12px 14px; border-radius: 12px;
             background: var(--cartao); border: 1px solid var(--flua-borda); text-decoration: none;
             transition: border-color .15s, box-shadow .15s; }
    .opcao:hover { border-color: color-mix(in srgb, var(--marca-acao) 45%, var(--flua-borda)); }
    .opcao:focus-visible { outline: 2px solid var(--marca-acao); outline-offset: 2px; }
    .icone { flex: none; display: grid; place-items: center; width: 36px; height: 36px; border-radius: 10px;
             background: var(--flua-rodape); color: var(--tx-2); }
    .texto { display: flex; flex-direction: column; min-width: 0; }
    .nome { font-size: 14px; font-weight: 700; color: var(--tx); }
    .descricao { font-size: 12px; color: var(--tx-3); margin-top: 2px; }
    .ativa { border-color: var(--marca-acao); box-shadow: inset 3px 0 0 var(--marca-acao); background: var(--marca-tint); }
    .ativa .icone { background: var(--marca-acao); color: #fff; }`],
})
export class RelatoriosAbasComponent {
  readonly opcoes: RelatorioOpcao[];
  constructor(localStorage: LocalStorageService) {
    const perfil = localStorage.get('profile');
    const lideranca = perfil === 'Administrador' || perfil === 'Supervisor';
    this.opcoes = RELATORIOS.filter(r => !r.lideranca || lideranca);
  }
}
